"use strict";

exports["default"] = Function.prototype.bind;
exports.__esModule = true;


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/helpers/bind.js
// module id = 155
// module chunks = 0